"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconBolt = function SvgIconBolt(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "bolt icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Bolt Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M37.923 16.462a.825.825 0 00-.746-.462h-9.759l9.631-14.772a.78.78 0 00.026-.814.828.828 0 00-.722-.414H23.177a.827.827 0 00-.737.442l-12.353 24a.78.78 0 00.036.778.83.83 0 00.7.38h8.47l-9.228 21.29a.79.79 0 00.329.992.838.838 0 001.06-.166l26.353-30.4a.783.783 0 00.116-.854z"
  }));
};

var _default = SvgIconBolt;
exports.default = _default;